import React from 'react';
import { LAST_REVIEWED, CRM, formatarData } from '../data/revision';

const references = [
  'Teasdale G, Jennett B. Assessment of coma and impaired consciousness. A practical scale. Lancet. 1974.',
  'Teasdale G, et al. The Glasgow Coma Scale at 40 years: standing the test of time. Lancet Neurol. 2014.',
  'Brennan PM, Murray GD, Teasdale GM. Simplifying the use of prognostic information in traumatic brain injury. J Neurosurg. 2018.',
];

export default function ReferencesAndAuthor() {
  return (
    <section id="referencias" className="references-author" aria-labelledby="references-title">
      <div className="references-author__refs">
        <span className="section-kicker">Fontes e revisão</span>
        <h2 id="references-title">Referências principais</h2>
        <ol>
          {references.map((reference, index) => (
            <li key={reference}>
              <span>{index + 1}</span>
              <p>{reference}</p>
            </li>
          ))}
        </ol>
        <a className="text-link" href="/referencias">Ver página completa de referências →</a>
      </div>

      <article className="author-card" aria-label="Autor e revisor técnico">
        <img
          src="/dr-carlos-felipe.jpg"
          alt="Dr. Carlos Felipe, autor e revisor técnico da Escala de Glasgow"
          title="Dr. Carlos Felipe — autor e revisor técnico"
          width="160"
          height="160"
          loading="lazy"
        />
        <div>
          <span className="author-card__label">Autor e revisor técnico</span>
          <h3>Dr. Carlos Felipe</h3>
          <p className="author-card__crm">Médico — CRM-MG 105.721</p>
          <p>
            Responsável pela revisão técnica e editorial deste conteúdo. A calculadora é uma ferramenta de apoio ao registro e à compreensão da Escala de Coma de Glasgow; a interpretação depende do contexto clínico.
          </p>
          <div className="author-card__meta">
            <span>Última revisão: {formatarData(LAST_REVIEWED)}</span>
            <span>{CRM}</span>
          </div>
          <div className="author-card__links">
            <a href="https://cadu.online" target="_blank" rel="me noopener noreferrer">Perfil profissional ↗</a>
            <a href="https://eidoc.com.br/ferramentas" target="_blank" rel="noopener noreferrer">Outras ferramentas na Ei Doc ↗</a>
          </div>
        </div>
      </article>
    </section>
  );
}
